import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Remover o loading screen quando o React carrega
const loading = document.getElementById('loading');
if (loading) {
  loading.style.display = 'none';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
